import React from 'react';
import EditorAlignLeft from '@wix/da-ds/pkg/Icons/24x24/EditorAlignLeft';
import EditorAlignRight from '@wix/da-ds/pkg/Icons/24x24/EditorAlignRight';
import EditorAlignCenter from '@wix/da-ds/pkg/Icons/24x24/EditorAlignCenter';
import { useTranslation } from 'react-i18next';
import EditorIconButtonWithContextMenu from '../../../../components/menus/_partials/EditorIconButtonWithContextMenu';
const Alignment = ({ editor })=>{
    const { t } = useTranslation('editor');
    let CurrentIcon = EditorAlignLeft;
    if (editor.isActive('da-gif', {
        alignment: 'right'
    })) {
        CurrentIcon = EditorAlignRight;
    }
    if (editor.isActive('da-gif', {
        alignment: 'center'
    })) {
        CurrentIcon = EditorAlignCenter;
    }
    if (!editor.can().chain().focus().daGifAlign('center').run()) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(EditorIconButtonWithContextMenu, {
        featureId: "node:gif:align",
        "aria-label": t('ext.gif.button.alignment'),
        tooltipText: t('ext.gif.button.alignment'),
        icon: CurrentIcon,
        items: [
            {
                featureId: 'node:gif:alignLeft',
                label: 'Left',
                icon: /*#__PURE__*/ React.createElement(EditorAlignLeft, null),
                selected: editor.isActive('da-gif', {
                    alignment: 'left'
                }),
                onClick: ()=>{
                    editor.chain().focus().daGifAlign('left').run();
                }
            },
            {
                featureId: 'node:gif:alignCenter',
                label: 'Center',
                icon: /*#__PURE__*/ React.createElement(EditorAlignCenter, null),
                selected: editor.isActive('da-gif', {
                    alignment: 'center'
                }),
                onClick: ()=>{
                    editor.chain().focus().daGifAlign('center').run();
                }
            },
            {
                featureId: 'node:gif:alignRight',
                label: 'Right',
                icon: /*#__PURE__*/ React.createElement(EditorAlignRight, null),
                selected: editor.isActive('da-gif', {
                    alignment: 'right'
                }),
                onClick: ()=>{
                    editor.chain().focus().daGifAlign('right').run();
                }
            }
        ]
    });
};
Alignment.displayName = 'Alignment';
export default Alignment;

//# sourceMappingURL=Alignment.js.map